"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FreightClassAnyOf = void 0;
exports.FreightClassAnyOf = {
    _50: '50',
    _55: '55',
    _110: '110',
    _150: '150',
    _200: '200',
    _500: '500',
    _775: '77.5'
};
//# sourceMappingURL=freight-class-any-of.js.map